import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {useMemo} from 'react';

type Props = {
  links: HeaderProps['links'];
  excludedTitles: string[];
};

export const useFilteredHeaderLinks = ({links, excludedTitles}: Props) =>
  useMemo(() => {
    if (!excludedTitles.length) {
      return links;
    }

    return links.filter((item) => !excludedTitles.includes(item.title));
  }, [links, excludedTitles]);
